<template> 
 <div class="shop" v-loading="loading">

     <el-button type="primary" size="mini" @click="exportOrderData"  style="float:left;">导出数据</el-button>
     
     <div style="float:right;margin-bottom:20px;">
         <el-date-picker v-model="created_at_GT"
          type="date"
          size="mini"
          style="width:136px"
          value-format="yyyy-MM-dd"
          placeholder="选择开始时间">
        </el-date-picker> ~ <el-date-picker v-model="created_at_LT"
          type="date"
          size="mini"
          style="width:136px;margin-right:12px;"
          value-format="yyyy-MM-dd"
          placeholder="选择结束时间"></el-date-picker>
          
          <el-select style="width:100px;margin-right:12px;"
          v-model="order_type"
          filterable
          size="mini"
          placeholder="缴费类型">
          <el-option 
            label="全部"
            value="0"></el-option>
        <el-option 
            label="全额入驻"
            value="40"></el-option>
        <!-- <el-option label="已核销"
            :value="10"></el-option> -->
        <!-- <el-option label="已取消"
            :value="15"></el-option> -->
            <el-option label="押金入驻"
            value="41"></el-option>
        </el-select>

          <el-select style="width:100px;margin-right:12px;"
          v-model="order_status"
          filterable
          size="mini"
          placeholder="订单状态">
          <!-- <el-option 
            label="待支付"
            :value="1"></el-option> -->
        <el-option 
            label="已支付"
            :value="5"></el-option>
        <!-- <el-option label="已核销"
            :value="10"></el-option> -->
        <!-- <el-option label="已取消"
            :value="15"></el-option> -->
            <el-option label="已关闭"
            :value="20"></el-option>
        </el-select>
        

         <el-input class="input"
        v-model="mobile"
        placeholder="输入用户账号搜索"
        clearable
        style="width:144px;margin-right:12px;"
        size='mini'></el-input>
         <el-input class="input"
        v-model="order_no"
        placeholder="输入订单编号搜索"
        clearable
        style="width:144px;margin-right:12px;"
        size='mini'></el-input>
      <el-button type="primary"
        @click="searchShopOrder"
        size='mini'>搜索</el-button>

     </div>
     

     <el-table 
      :data="tableData"
      style="width:100%;margin:20px 0;"
      max-height="600"
      :cell-style="tc"
      :header-cell-style="tccolor">
      
    <el-table-column label="订单编号" prop="order_no"></el-table-column>
    <el-table-column label="下单用户" >
        <template slot-scope="scope">
            <p v-if="scope.row.user_with_shop">{{scope.row.user_with_shop.username}}</p>
        </template>
    </el-table-column>
    <el-table-column label="付款金额">
        <template slot-scope="scope">
            <p v-if="scope.row.price">¥{{scope.row.price}}</p>
            <p v-else>---</p>
        </template>
    </el-table-column>
    <el-table-column label="已认领小店" >
        <template slot-scope="scope">
            <p v-if="scope.row.user_with_shop  && scope.row.user_with_shop.shop">{{scope.row.user_with_shop.shop.shop_name}}</p>
            <p v-else>---</p>
        </template>
    </el-table-column>
    <el-table-column label="小店地址" >
        <template slot-scope="scope">
            <p v-if="scope.row.user_with_shop  && scope.row.user_with_shop.shop">{{scope.row.user_with_shop.shop.address}}</p>
            <p  v-else>---</p>
        </template>
    </el-table-column>

    <el-table-column label="支付流水号" >
       <template slot-scope="scope">
         <p v-if="scope.row.out_order_no">{{scope.row.out_order_no}}</p>
         <p v-else>---</p>
       </template>
    </el-table-column>
    <el-table-column label="支付状态">
        <template slot-scope="scope">
            <p v-if='scope.row.order_status==1'>待付款</p>
          <p v-if='scope.row.order_status==5'>已支付</p>
       
          <p v-if='scope.row.order_status==15'>已取消</p>
          <!-- <p v-if='scope.row.refund_status==5'>退款申请中</p> -->
          <!-- <p v-if='scope.row.order_status==20'>已关闭</p> -->
        </template>
    </el-table-column>
    <el-table-column label="缴费类型">
     <template slot-scope="scope">
         <p v-if="scope.row.order_type == 40">全额入驻</p>
      <p v-if="scope.row.order_type == 41">押金缴费入驻</p>
     </template>
    </el-table-column>
    <el-table-column label="创建时间" prop="created_at"></el-table-column>
    </el-table>

     <div class="pagination">
        <el-pagination
          background
          @current-change="pageChange"
          :current-page="page"
          :page-size="size"
          layout="total, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
 </div>
</template>

<script>

import {shoporderSerchordertype} from "@/api/goods"
import { API_BASE_URL } from "@/config";
export default {
    data(){
        return {
            loading:true,
            is_export:'',
            created_at_GT:'',
            created_at_LT:'',
            page:1,
            size:15,
            order_status:'',
            order_type:'',
            mobile:'',
            order_no:'',
            total:0,
            tableData:[]
        }
    },
    created(){
     this.getshoporderSerchordertypeData()
    },
    mounted(){

    },
    methods:{
      searchShopOrder(){
        this.getshoporderSerchordertypeData()
      },
      pageChange(page){
          this.page  = page
          this.getshoporderSerchordertypeData()
      },
     exportOrderData(){
       this.is_export = 1
       this.getshoporderSerchordertypeData()
     },
    //获取加盟订单列表
    async getshoporderSerchordertypeData(){

      if(this.order_type == 0) {
        this.order_type = ''
      }
      var url = '&order_status='+this.order_status+
                '&order_no='+this.order_no+
                '&created_at_GT='+this.created_at_GT+
                '&created_at_LT='+this.created_at_LT+
                '&mobile='+this.mobile+
                '&page='+this.page+
                '&is_export='+this.is_export+
                '&order_type=40'+
                '&order_types[]='+this.order_type
      let res = await shoporderSerchordertype(url)
      if(res.code === 10000){
          if(this.is_export == 1){
             this.is_export = ''
             window.open(
          `${API_BASE_URL}/admin/download/zip/${res.data[1].download_token}`
        );
          }else{
            this.loading = false
          this.tableData = res.data.data
          this.total = res.data.total
          }
      }else{
          this.loading = false
          this.$message.error(res.message)
      }
    },

   
    tc () {
      return "text-align:center; color:#333333; font-size:12px;";
    },
    tccolor () {
      return "text-align:center;background-color:#f5f5f5; font-size:14px;";
    },
    }
}

</script>

<style lang="scss" scoped>
.shop{
    padding: 20px;

    .pagination{
        float: right;
        margin-top: 20px;
    }
}
</style>